
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(13680|23976)$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
